(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      const search = document.querySelector('.header__search');
      const searchDetails = search.querySelector('details');

      // Check if on homepage
      this.isHomePage = window.location.pathname === '/';

      // Get transparency settings
      this.headerIsTransparent = this.getAttribute('data-menu-transparent') === 'true';
      this.headerBackgroundColor = this.getAttribute('data-menu-color');

      if(this.headerIsTransparent) {
        search.addEventListener('click', () => {
          if(searchDetails.hasAttribute('open')) {
            body.classList.remove('search-open');
          } else {
            body.classList.add('search-open');
          }

          // Check every 10ms if search is open
          const interval = setInterval(() => {
            if(searchDetails.hasAttribute('open')) {
              body.classList.add('search-open');
            } else {
              body.classList.remove('search-open');

              const isMobile = window.matchMedia('(max-width: 990px)').matches;

              if(isMobile) {
                this.style.background = 'transparent';
              }

              clearInterval(interval);
            }
          }, 10);

          setTimeout(() => {
            if(!body.classList.contains('search-open') && !this.header.classList.contains('scrolled-past-header')) {
              this.style.background = 'transparent';
            } else {
              this.style.background = this.headerBackgroundColor;
            }
          }, 100);
        });

        // Interval on if mobile and menu is open
        // const menuInterval = setInterval(() => {
        //   const isMobile = window.matchMedia('(max-width: 990px)').matches;
        //   const isMenuOpen = this.header.classList.contains('menu-open');
        //   const searchIcon = document.querySelector('.search-icon-path');

        //   if(isMobile && isMenuOpen) {
        //     searchIcon.style.fill = '{{ section.settings.menu_items_color }}';
        //     searchIcon.style.stroke = '{{ section.settings.menu_items_color }}';
        //   } else {
        //     searchIcon.style.fill = '{{ section.settings.transparent_menu_items_color }}';
        //     searchIcon.style.stroke = '{{ section.settings.transparent_menu_items_color }}';
        //   }
        // }, 100);  
      }

      // Ensure correct initial state on page load
      this.updateHeaderItemsColor();

      // Modify initial background based on scroll and homepage
      if (window.pageYOffset === 0 && this.headerIsTransparent && this.isHomePage) {
        this.style.background = 'transparent';
      } else {
        this.style.background = this.headerBackgroundColor;
        // Ensure menu items are in menu_items_color when scrolled
        this.header.classList.add('scrolled-past-header');
      }

      const mobileMenuButton = this.querySelector('.click-mobile-menu');
      const menuDrawer = this.querySelector('.menu-drawer-container');

      // Transparent header logic for homepage
      if (this.headerIsTransparent && this.isHomePage) {
        const handleScroll = () => {
          const isHovering = this.matches(':hover');

          if(isHovering) {
            this.header.classList.add('hovering');
          } else {
            this.header.classList.remove('hovering');
          }

          if (window.pageYOffset === 0) {
            document.body.classList.add('transparent-header-active');

            const isMobile = window.matchMedia('(max-width: 990px)').matches;

            if(isMobile) {
              this.style.background = 'transparent';
            } else {
              // Always use menu color when hovering, otherwise use transparent
              this.style.background = isHovering ? this.headerBackgroundColor : 'transparent';
            }
          } else {
            document.body.classList.remove('transparent-header-active');
            // this.style.background = this.headerBackgroundColor;

            if(!this.header.classList.contains('scrolled-past-header')) {
              this.style.background = 'transparent';
            }
          }

          // Update header items color
          this.updateHeaderItemsColor();
        };

        // Initial check
        handleScroll();

        // Listen for scroll and mousemove events to update hover state
        window.addEventListener('scroll', handleScroll);
        this.addEventListener('mouseenter', handleScroll);
        this.addEventListener('mouseleave', handleScroll);
      }

      mobileMenuButton.addEventListener('click', () => {
        if (window.pageYOffset === 0 && this.headerIsTransparent) {
          if (!menuDrawer.hasAttribute('open')) {
            this.style.background = this.headerBackgroundColor;
          } else {
            this.style.background = 'transparent';
          }
        }
      });

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // New method to update header items color
    updateHeaderItemsColor() {
      if (!this.headerIsTransparent || !this.isHomePage) return;

      const isScrolled = window.pageYOffset > 0;
      const isHovering = this.matches(':hover');

      // Select all elements that change color based on transparency
      const colorElements = [
        ...this.querySelectorAll('.header__menu-item'),
        ...this.querySelectorAll('.header__icon--cart svg path'),
        ...this.querySelectorAll('.header__icon--account svg'),
        ...this.querySelectorAll('.header__icon--menu .icon-hamburger'),
        ...this.querySelectorAll('.header__icon--menu .icon-close'),
        ...this.querySelectorAll('.search-icon-path'),
        ...this.querySelectorAll('#wishlist-header-link-1 .wk-icon svg path')
      ];

      colorElements.forEach(el => {
        if (isScrolled || isHovering) {
          // When scrolled or hovering, use menu_items_color
          if (el.classList.contains('header__menu-item')) {
            el.style.color = '{{ section.settings.menu_items_color }}';
          } else if (el.tagName.toLowerCase() === 'path') {
            el.style.stroke = '{{ section.settings.menu_items_color }}';
            el.style.fill = '{{ section.settings.menu_items_color }}';
          } else {
            el.style.fill = '{{ section.settings.menu_items_color }}';
          }
        } else {
          // Reset to transparent menu items color
          if (el.classList.contains('header__menu-item')) {
            el.style.color = '{{ section.settings.transparent_menu_items_color }}';
          } else if (el.tagName.toLowerCase() === 'path') {
            el.style.stroke = '{{ section.settings.transparent_menu_items_color }}';
            el.style.fill = '{{ section.settings.transparent_menu_items_color }}';
          } else {
            el.style.fill = '{{ section.settings.transparent_menu_items_color }}';
          }
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const header = document.querySelector('.shopify-section-header-sticky');
      const headerHeight = header.offsetHeight;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Determine if currently hovering
      const isHovering = this.matches(':hover');

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

        // Always use menu color when scrolled past
        if (this.headerIsTransparent && this.isHomePage) {
          this.style.background = this.headerBackgroundColor;
          this.updateHeaderItemsColor();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));

          // Always use menu color when scrolled past
          if (this.headerIsTransparent && this.isHomePage) {
            this.style.background = this.headerBackgroundColor;
            this.updateHeaderItemsColor();
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));

        // Back to transparent or menu color based on hover
        if (this.headerIsTransparent && this.isHomePage) {
          const isMobile = window.matchMedia('(max-width: 990px)').matches;

          if(isMobile) {
            this.style.background = 'transparent';
          } else {
            this.style.background = isHovering ? this.headerBackgroundColor : 'transparent';
          }

          this.updateHeaderItemsColor();
        }
      }

      this.currentScrollTop = scrollTop;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    // Rest of the methods remain the same...
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide"] && !window.DesignMode) return;
  try {
    
  const categoryMobileButton = document.querySelector('.guide-mobile-categories');
  const categoryMobileDropdown = document.querySelector('.guide-mobile-categories-dropdown');

  categoryMobileButton.addEventListener('click', () => {
    categoryMobileDropdown.classList.toggle('hidden');
  });

  document.addEventListener('click', (e) => {
    if (!categoryMobileButton.contains(e.target)) {
      categoryMobileDropdown.classList.add('hidden');
    }
  });

  const activeCategoryMobile = document.querySelector('.guide-mobile-categories-dropdown .blog-category--active');
  const allCategoriesMobile = document.querySelector('.all-categories-mobile');

  if (activeCategoryMobile) {
    allCategoriesMobile.classList.remove('blog-category--active');
  } else {
    allCategoriesMobile.classList.add('blog-category--active');
  }

  } catch(e) { console.error(e); }
})();
})();
